// Regras puras do Painel ao Vivo (/moments).
// Separadas dos componentes para ficarem testáveis sem montar o React.
import { i18n } from "../../translate/i18n";

const doisDigitos = (n) => String(n).padStart(2, "0");

/**
 * Horário curto da última mensagem, como no mockup: "14:06" no mesmo dia,
 * "Ontem" no dia anterior e "dd/MM" antes disso.
 *
 * O painel é de acompanhamento ao vivo — a data cheia ("05/09/2026") ocupa a
 * linha do nome e não diz nada de útil para quem está olhando a fila agora.
 * O ano só apareceria em ticket muito antigo, que não pertence a esta tela.
 */
export const ticketTime = (updatedAt, agora = new Date()) => {
  if (!updatedAt) return "";
  const data = new Date(updatedAt);
  if (Number.isNaN(data.getTime())) return "";

  const dia = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const diffDias = Math.round((dia(agora) - dia(data)) / (1000 * 60 * 60 * 24));

  if (diffDias === 0) {
    return `${doisDigitos(data.getHours())}:${doisDigitos(data.getMinutes())}`;
  }
  if (diffDias === 1) return i18n.t("aeros.moments.yesterday");
  return `${doisDigitos(data.getDate())}/${doisDigitos(data.getMonth() + 1)}`;
};

/**
 * Prévia da última mensagem em uma linha.
 *
 * Quebras de linha viram espaço: sem isso, uma mensagem com Enter empurraria
 * o resto do card para baixo e desalinharia a coluna inteira.
 */
export const lastMessagePreview = (texto) =>
  (texto || "").replace(/\s*\n+\s*/g, " ").trim();

// "JP" a partir de "Juliana Prado"; uma letra só quando o nome tem uma palavra.
export const initials = (name = "") =>
  name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((parte) => parte[0])
    .join("")
    .toUpperCase();

/**
 * Se o usuário logado pode abrir o ticket a partir do painel.
 *
 * Admin abre qualquer um; atendente abre só os seus. Ticket sem atendente
 * (coluna "Aguardando") não abre por ninguém — no mockup o olho nem aparece
 * ali, porque abrir sem assumir deixaria a fila em estado ambíguo.
 */
export const canOpenTicket = (ticket, user) => {
  if (!ticket?.userId) return false;
  if (user?.profile === "admin") return true;
  return Number(ticket.userId) === Number(user?.id);
};
